<app-shared-dialog
  [title]="'inventory.product_information' | translate"
  [options]="{
    size: 'large',
    titleIcon: 'pen-cc',
    titleIconColor: 'primary',
    confirmText: 'common.save' | translate,
    cancelText: 'common.cancel' | translate,
    confirmButtonStyle: 'primary-btn',
    customConfirmButton: true
  }"
  (cancel)="cancel()"
  class="edit-variant-product-infos-dialog"
>
  <form class="information-form" [formGroup]="form">
    <div class="form-content">
      <!-- Product Name -->
      <div class="standard-input">
        <label for="name">{{
          "inventory.product_details.product_name" | translate
        }}</label>
        <input
          type="text"
          formControlName="name"
        />
        <div
          class="error"
          *ngIf="
            form.get('name')?.invalid &&
            (form.get('name')?.touched || form.get('name')?.dirty)
          "
        >
          <small *ngIf="form.get('name')?.hasError('required')">{{
            "inventory.validation.details_form.name.required" | translate
          }}</small>
        </div>
      </div>

      <!-- Brand -->
      <div class="standard-input">
        <label for="brandControl">{{ "brands.brand" | translate }}</label>
        <input
          type="text"
          class="is-autocomplete"
          placeholder="Select"
          name="brandControl"
          matInput
          formControlName="brandControl"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <ng-container *ngIf="filteredBrands$ | async as brands">
            <mat-option *ngFor="let brand of brands" [value]="brand.name" (click)="onBrandSelected(brand)">
              {{ brand.name }}
            </mat-option>
          </ng-container>
        </mat-autocomplete>
      </div>
      <!-- Status -->
      <div class="standard-input">
        <label for="status">{{ "common.status" | translate }}</label>
        <select name="status" id="status" formControlName="status">
          <option value="Draft">{{ "common.draft" | translate }}</option>
          <option value="Published">{{ "common.published" | translate }}</option>
        </select>
      </div>
      <!-- Description -->
      <div class="standard-input">
        <label for="description">{{ "common.description" | translate }}</label>
        <textarea
          id="description"
          autocomplete="off"
          placeholder="Add a product description"
          name="description"
          formControlName="description"
          rows="2"
          style="resize: vertical"
        ></textarea>
      </div>

      <div class="divider"></div>
      <!-- Variant -->
      <div class="variants-container-title">
      {{"inventory.product_edit_basic_infos.variants_details" | translate}}
      </div>
      <div class="variants-container">
        <table class="variants-table">
            <thead>
              <tr class="row header">
                <th>
                  {{"inventory.product_edit_basic_infos.variant" | translate}}
                </th>
                <th>
                  {{"inventory.sku"|translate}}
                </th>
                <th>{{"inventory.ean"|translate}}</th>
                <th>{{"inventory.product_edit_basic_infos.extra_ids"|translate}}</th>
              </tr>
            </thead>
            <tbody [formGroup]="variantsForm">
                <ng-container *ngFor="let variant of data.variants; let i = index">
                  <tr class="row body">
                    <td>
                        <div class="variant-name">
                            <mat-slide-toggle class="checkbox_table" [formControlName]="'enabled_' + variant.id" [checked]="variantsForm.get('enabled_' + variant.id)?.value"
                            ></mat-slide-toggle>
                            <div class="tags-container">
                                <span class="tag" *ngFor="let value of variant.values">
                                    {{value}}
                                </span>
                            </div>
                        </div>
                    </td>   
                    <td>
                      <input type="text" [formControlName]="'sku_' + variant.id" [placeholder]="'inventory.sku'|translate">
                    </td> 
                    <td>
                        <input type="text" [formControlName]="'barcode_' + variant.id" [placeholder]="'inventory.ean'|translate">
                    </td>          
                    <td>
                        <mat-chip-list #chipList [formControlName]="'extra_identifiers_' + variant.id">
                            <mat-chip *ngFor="let extra_identifier of getExtraIdentifiers(variant.id)" [selectable]="true" [removable]="true" (removed)="removeExtraIdentifier(variant, extra_identifier)">
                              {{ extra_identifier }}
                              <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip>
                            <input
                              placeholder="Add IDs"
                              [matChipInputFor]="chipList"
                              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                              [matChipInputAddOnBlur]="true"
                              (matChipInputTokenEnd)="addExtraIdentifier(variant, $event)"
                            />
                          </mat-chip-list>
                    </td>
                  </tr>
                </ng-container>
            </tbody>
          </table>
      </div>

      <!-- Expiry Date -->
      <div class="row-checkbox">
        <mat-checkbox
          [checked]="form.get('hasExpirationDate')?.value"
            (change)="toggleExpirationDate($event)"
          >
        </mat-checkbox>
        <span class="label">
          {{ "inventory.product_details.has_expiration_date" | translate }}
        </span>
      </div>
      <div class="standard-input has-icon" *ngIf="form.get('hasExpirationDate')?.value">
        <label for="expiry_date"
          >{{
            "inventory.product_details.select_expiration_date" | translate
          }}
        </label>
        <div class="input-container">
          <input
            type="text"
            [matDatepicker]="picker"
            formControlName="expiry_date"
            [placeholder]="'inventory.product_details.select_date' | translate"
            readonly="true"
            (click)="picker.open()"
          />
          <button
            type="button"
            class="btn-icon"
            (click)="picker.open()"
            tabindex="-1"
            aria-label="Open calendar"
          >
            <app-svg-icon svgIcon="calendar-cc"></app-svg-icon>
          </button>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
    </div>
  </form>
  <ui-button
    customConfirm
    *appHasPermission="{ module: 'product', action: 'edit' }"
    type="primary"
    [label]="'common.save' | translate"
    (click)="save()">
  </ui-button>
</app-shared-dialog>
